import React from 'react';
import {Grid, Modal} from "@mui/material";

import {connect} from "react-redux";
import {HomeForm} from "./homeFormComponent";
import {Trans, withTranslation} from "react-i18next";
import {BalloonNotification} from "../../../components/BalloonNotification";
import Button from "@mui/material/Button";
import {
    createNotification,
    listNotifications,
    removeNotification,
    setNotification,
    unsetNotification,
    acceptReminder, getReminders
} from "../../user/user.actions";
import {
    listMunicipalities
} from "../../municipality/municipality.actions";
import {
    hasPermission,
    PERMISSION_CREATE_SYSTEM_WIDE_NOTIFICATION,
    PERMISSION_CREATE_MUNICIPALITY_WIDE_NOTIFICATION
} from "../../../permissions";
import {formatDateStr} from "../../../utils";
import { ButtonSecondary } from '../../../components/newComponents/ButtonSecondary';
import { ButtonPrimary } from '../../../components/newComponents/ButtonPrimary';
import {getReminderContent, getReminderTitle} from "../../root/root.utils";
import {getFunction} from "../../function/function.actions";
import {askUpdates} from "../../root/root.actions";


const mapStateToProps = (state) => {
    return {
        authenticatedUser: state.auth.authenticatedUser,
        selectedNotification: state.user.selectedNotification,
        notifications: state.user.notifications,
        reminders: state.user.reminders,
        municipalities: state.municipality.municipalities
    }
}

const mapDispatchToProps = dispatch => {
    return {
        askUpdates: () => dispatch(askUpdates()),
        listMunicipalities: () => dispatch(listMunicipalities()),
        setNotification: (data) => dispatch(setNotification(data)),
        unsetNotification: () => dispatch(unsetNotification()),
        listNotifications: () => dispatch(listNotifications()),
        createNotification: (data, onSuccess) => dispatch(createNotification(data, onSuccess)),
        removeNotification: (id, onSuccess) => dispatch(removeNotification(id, onSuccess)),
        getFunction: (id) => dispatch(getFunction(id)),
        acceptReminder: (id) => dispatch(acceptReminder(id)),
        getReminders: () => dispatch(getReminders())
    };
}

class HomePageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.props.askUpdates();
        this.props.listMunicipalities();
        this.props.listNotifications();
        this.props.getReminders();

        const action = this.props.action;
        let notificationModalOpen = false;
        if (action === 'create') {
            this.props.unsetNotification();
            notificationModalOpen = true;
        }

        this.state = {
            notificationModalOpen: notificationModalOpen,
            removeModalOpen: false,
            allPartitionsOpen: false,
            editNotification: null
        }

        this.handleCreateNew = this.handleCreateNew.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.remove = this.remove.bind(this);
        this.openRemoveModal = this.openRemoveModal.bind(this);
        this.closeRemoveModal = this.closeRemoveModal.bind(this);
        this.getTitle = this.getTitle.bind(this);
        this.accept = this.accept.bind(this);
    }

    handleCreateNew(event) {
        event.preventDefault()
        this.props.unsetNotification()
        this.setState({
            ...this.state,
            allPartitionsOpen: false,
            notificationModalOpen: true
        })
    }

    remove(event) {
        event.preventDefault()
        this.props.removeNotification(this.props.selectedNotification.id, () => {
            this.setState({
                ...this.state,
                removeModalOpen: false,
                notificationModalOpen: false,
            });
            this.props.listNotifications();
            return unsetNotification();
        })
    }

    openEditModal(event, notificationId) {
        for (var nots of this.props.notifications) {
            console.log(nots);
            if (nots.id === notificationId) {
                console.log("found")
                this.props.setNotification(nots);
                this.setState({
                    ...this.state,
                    removeModalOpen: false,
                    notificationModalOpen: true
                });
                return;
            }
        }
    }

    openRemoveModal(event, notificationId) {
        event.preventDefault()
        this.props.setNotification({id: notificationId})
        this.setState({...this.state, removeModalOpen: true})
    }

    closeRemoveModal(event) {
        event.preventDefault()
        this.setState({...this.state, removeModalOpen: false})
    }

    closeModal(event) {
        event.preventDefault()
        this.setState({...this.state, notificationModalOpen: false})
    }

    handleChange(e, changedData) {
        let data = {
            ...this.props.selectedNotification
        }
        if (e) {
            data = {
                ...this.props.selectedNotification,
                [e.target.name]: e.target.value
            }
        }
        if (changedData) {
            data = {
                ...this.props.selectedNotification,
                ...changedData
            }
        }

        this.props.setNotification(data);
    }


    _createNotification(data) {
        this.props.createNotification(data, data => {
            this.setState({...this.state, notificationModalOpen: false})
            this.props.listNotifications();
            return setNotification(data);
        })
    }

    handleSubmit(event, props) {
        const notificationData = {...props};
        this._createNotification(notificationData);

    }

    getTitle = (notification) => {
        const titles = {
            'INSTRUCTION': this.props.t('notification.instruction_title'),
            'INFORMATION': this.props.t('notification.information_title'),
            'NOTIFICATION': this.props.t('notification.notification_title'),
        }
        if (notification.notificationType == null) {
            return "";
        }
        return titles[notification.notificationType.toUpperCase()];
    }

    getMunicipality = (municipalityId) => {
        if (municipalityId === null || municipalityId === undefined) {
            return this.props.t('notification.all_municipalities');
        }

        for (var municipality of this.props.municipalities) {
            if (municipality.id === municipalityId) {
                return municipality.name;
            }
        }
    }

    accept(id) {
        this.props.acceptReminder(id);
    }

    render() {
        const {t} = this.props;

        let actionButtons = [
            {
                type: "secondary",
                label: t('common.close_without_saving'),
                className: "",
                onClick: this.closeModal
            },
            {
                type: "main",
                label: t('common.save'),
                className: "",
                onClick: this.handleSubmit
            },
        ];

        return (
            <div>
                <Grid container spacing={1}>
                    {this.props.reminders.map((row, index) => {
                        let extraElements = [
                            (<div>{formatDateStr(row.createdAt)}</div>),
                        ];
                        if(row.reminderType === 'FUNCTION_PARTICIPANTS_MISSING') {
                            extraElements.push((
                                <Button href={'/function/createFunction/edit/'+row.targetId}> 
                                    <img className="reminder-button-icon-img"
                                         src={process.env.PUBLIC_URL + '/media/images/icons/IconMove.svg'}
                                         alt={t("reminder.go_to")}/>
                                    <span>{t('reminder.go_to')}</span>
                                </Button>
                            ));
                        }
                        else {
                            extraElements.push((
                                <Button onClick={() => this.accept(row.id)}> 
                                    <span>{t('reminder.accept')}</span>
                                </Button>
                            ));
                        }
                        return (
                            <Grid
                                key={`reminder-grid-content-${index}`}
                                size={{
                                    sm: 12,
                                    md: 6
                                }}>
                                <BalloonNotification
                                    title={t(getReminderTitle(row.reminderType))}
                                    content={t(getReminderContent(row.reminderType))}
                                    severity={'reminder'}
                                    extraElements={extraElements}
                                />
                            </Grid>
                        );})}
                    {this.props.notifications.map((row, index) => (
                        <Grid
                            key={`notification-grid-content-${index}`}
                            size={{
                                sm: 12,
                                md: 6
                            }}>
                            <BalloonNotification
                                title={this.getTitle(row)}
                                header={row.header ? row.header : null}
                                content={row.content}
                                municipality={this.getMunicipality(row.municipalityId)}
                                userName={row.userName ? row.userName : null}
                                severity={row.notificationType.toLowerCase()}
                                extraElements={[
                                    (row.startDatetime && <div>{formatDateStr(row.startDatetime)}</div>),
                                    (row.endDatetime && <div className={'bold'}>{t('notification.will_be_removed')} {formatDateStr(row.endDatetime)}</div>),
                                    <Grid sx={{paddingLeft: "0px !important"}} container spacing={2} className={'button-grid'} direction="row" justifyContent="flex-start" alignItems="center">
                                        {(row.notificationVisibility === "ALL_MUNICIPALITIES" && hasPermission(PERMISSION_CREATE_SYSTEM_WIDE_NOTIFICATION, this.props.authenticatedUser)) ||
                                        (row.notificationVisibility !== "ALL_MUNICIPALITIES" && hasPermission(PERMISSION_CREATE_MUNICIPALITY_WIDE_NOTIFICATION, this.props.authenticatedUser)) ? (
                                            <>
                                                <Grid item>
                                                    <Button sx={{border: "1px solid"}} className={'button-primary'} onClick={(e) => this.openEditModal(e, row.id)}>
                                                        {t('notification.edit_notification')}
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button className={'button-attention'} onClick={(e) => this.openRemoveModal(e, row.id)}>
                                                        {t('notification.remove_notification')}
                                                    </Button>
                                                </Grid>
                                            </>
                                        ) : (
                                            <Grid item><div/></Grid>
                                        )}
                                    </Grid>
                                ]}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Modal
                    open={this.state.notificationModalOpen}
                    onClose={this.closeModal}
                >
                    <div className={'modal'}>
                        <HomeForm
                            label={t('notification.create_new_notification')}
                            onChange={this.handleChange}
                            getTitle={this.getTitle}
                            getMunicipality={this.getMunicipality}
                            selectedNotification={this.props.selectedNotification}
                            fieldErrors={this.props.notificationFieldErrors}
                            actionButtons={actionButtons}
                        />
                    </div>
                </Modal>
                <Modal
                    open={this.state.removeModalOpen}
                    onClose={this.closeRemoveModal}
                >
                    <div className={'modal archiveModal'}>
                        <div className={'modalDescription'}>
                            <Trans i18nKey="notification.remove_desc"/>
                        </div>
                        <div className={'modalQuestion'}>
                            {t('notification.remove_question')}
                        </div>
                        <div className={'modalButtons'}>
                            <ButtonSecondary onClick={this.closeRemoveModal}>
                                {t('common.cancel')}
                            </ButtonSecondary>
                            <ButtonPrimary onClick={this.remove}>
                                {t('common.remove')}
                            </ButtonPrimary>
                        </div>

                    </div>
                </Modal>
            </div>
        );
    }
}

const HomePage = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation('translation')(HomePageComponent));

export {HomePage};